import isFinite from 'lodash/isFinite';
import moment from 'moment';

import {
  SECTION_TITLE_HEIGHT,
  TILE_HEIGHT,
  NO_REQUESTS_HEIGHT,
  GAP_HEIGHT,
} from './constants';

export const getSectionRowHeight = ({is_header, is_empty, is_last}) => {
  const headerHeight = is_header ? SECTION_TITLE_HEIGHT : 0;

  let contentHeight = NO_REQUESTS_HEIGHT;
  if (!is_empty) {
    contentHeight = TILE_HEIGHT;
    if (!is_last) {
      contentHeight += GAP_HEIGHT;
    }
  }

  return headerHeight + contentHeight;
};

export const createCalendarSections = (requests, now = moment()) => {
  const normalized = requests ?? [];
  const dates = [];
  let sections = [];

  const start = moment.min(
    moment(normalized?.[0]?.date ?? new Date(), 'YYYY-MM-DD').startOf('week'),
    now.clone().add(-1, 'months').startOf('week'),
  );

  const end = moment.max(
    moment(
      normalized?.[normalized.length - 1]?.date ?? new Date(),
      'YYYY-MM-DD',
    ).endOf('week'),
    now.clone().add(1, 'months').endOf('week'),
  );

  while (start.isSameOrBefore(end, 'date')) {
    const key = start.format('YYYY-MM-DD');
    const daySection = normalized.filter((item) => item.date === key);

    if (daySection.length > 0) {
      daySection[0] = {
        ...daySection[0],
        is_header: true,
      };

      daySection[daySection.length - 1] = {
        ...daySection[daySection.length - 1],
        is_last: true,
      };

      sections = [...sections, ...daySection];
    } else {
      sections = [
        ...sections,
        {
          date: key,
          is_header: true,
          is_empty: true,
        },
      ];
    }

    dates.push(moment(key, 'YYYY-MM-DD'));
    start.add(1, 'day');
  }

  return {sections, dates};
};

export const getOffsetForDate = (sections, key, savedOffset) => {
  if (isFinite(savedOffset)) {
    return savedOffset;
  }

  let offset = 0;
  const todayIndex = sections.findIndex(
    (request) => request.is_header && request.date === key,
  );

  for (let i = 0; i < todayIndex; i++) {
    offset += getSectionRowHeight(sections[i]);
  }

  return offset;
};

export const getDateIndexByKey = (dates, key) =>
  dates.findIndex((date) => date.format('YYYY-MM-DD') === key);

export const getVisibleDateIndexFromScroll = ({
  contentOffset,
  contentSize,
  height,
  sections,
  dates,
  firstVisibleIndex,
}) => {
  const index =
    contentOffset.y < contentSize.height - height
      ? firstVisibleIndex
      : sections.length - 1;

  const key = sections[index]?.date;
  return getDateIndexByKey(dates, key);
};

export const getDateLabel = (date, now = moment()) => {
  if (date.isSame(now, 'date')) {
    return 'Vandaag';
  }

  if (date.isSame(now.clone().add(1, 'day'), 'date')) {
    return 'Morgen';
  }

  const text = date.format('dddd D MMMM');
  return `${text[0].toUpperCase()}${text.substring(1)}`;
};
